import { Login } from "@mui/icons-material";
import { AppBar, Box, Button, IconButton, Toolbar } from "@mui/material";
export default function PkCommonBar(props) {
  const { color } = props;
  return (
    <AppBar sx={{ px: `5%`, py: "1rem", border: 0 }} position="static">
      <Toolbar sx={{ justifyContent: "space-between" }}>
        <IconButton
          sx={{ "&:hover": { backgroundColor: "transparent" } }}
          href="/"
        >
          <img
            src="https://website-img.polycaik.com/w/brand/brand-v1-h.svg"
            alt="logo"
            height={30}
          />
        </IconButton>
        <IconButton
          sx={{ display: { xs: `block`, sm: "none" } }}
          href="https://dev.polycaik.com"
        >
          <Login
            sx={{
              color: props.color
                ? props.color
                : (theme) => theme.palette.grey[600],
            }}
          />
        </IconButton>
        <Box sx={{ display: { xs: `none`, sm: "flex" }, alignItems: "center" }}>
          <Login sx={{ color: props.color }} />
          <Button
            variant="contained"
            href="https://dev.polycaik.com"
            sx={{
              ml: 1,
              minWidth: "100px",
            }}
          >
            {props.title}
          </Button>
        </Box>
      </Toolbar>
    </AppBar>
  );
}
